import { render, staticRenderFns } from "./MenuIcon.vue?vue&type=template&id=5fee819d&scoped=true&"
import script from "./MenuIcon.vue?vue&type=script&lang=js&"
export * from "./MenuIcon.vue?vue&type=script&lang=js&"
import style0 from "./MenuIcon.vue?vue&type=style&index=0&id=5fee819d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fee819d",
  null
  
)

export default component.exports